<!--Barra de menu-->
<navbar-component></navbar-component>

<!--Conteúdo da página-->
<main class="fundo">

    <!-- Page Content goes here -->
    <div class="container">

        <!-- Texto de apresentação do Projeto-->
        <div class="container">
            <div class="row">
                <div class="col-lg-4 text-center" id="texto-apresentacao">
                    <h5>GRUPO DE PESQUISA</h5>
                    <h4>Nutrientes Criativos – design para a sustentabilidade</h4>
                    <p class="lh-base">Grupo de  pesquisa oficial do CNPQ fundado em 2019 focado na sustentabilidade econômica, cultural, social e ambiental por meio da construção de ciclos de vida circulares e de produções regenerativas. Acredita no resíduo como nutriente, elemento que alimenta, sustenta e promove atividades produtivas sustentáveis.</p>
                    <p class="lh-base">Desenvolve projetos de pesquisa, extensão e ensino, bem como assessoria técnica e acadêmica em projetos com foco em sustentabilidade. E busca divulgar e disponibilizar, de forma gratuita e acessível (em diversas linguagens), conteúdos informativos e educativos nas áreas de design, moda e produção geral no contexto da sustentabilidade.</p>
                    <p class="lh-base">Este site, portanto, é um veículo de comunicação, um banco de dados e um facilitador de negócio. Você pode se cadastrar para (a) divulgar seus materiais, produtos e atividades, (b) receber informações, (c) doar ou receber resíduos e muito mais. Não é um espaço de comercialização, mas criação de parcerias.</p>
                </div>
                <div class="col-sm-9"></div>
            </div>

            <!-- Caminho de botões -->
            <div class="container">
                <div class="row">

                   

                    <!-- Mídias sociais -->
                    <div class="col-sm-4">
                        <div class="fixed-btn direction-top">
                            <a class="btn-floating btn-large waves-effect waves-light green darken-1 instagram-icon social-network"
                                    href="https://www.instagram.com/nutrientescriativos/" title="Instagram"><img src="assets/icons/instagram-icon.svg" alt="ícone do Instagram"></a>
                            <a class="btn-floating btn-large waves-effect waves-light green darken-1 social-network"
                                    href="https://www.facebook.com/profile.php?id=100068232791129" title="Facebook"><img
                                        src="assets/icons/facebook-icon.svg" alt="Ícone do facebook"></a>
                            <a class="btn-floating btn-large waves-effect waves-light green darken-1 social-network"
                                    href="https://medium.com" title="Blog"><i class="material-icons"
                                        alt="Ícone do blog">share</i></a>
                        </div>
                    </div>

                </div>
                <!--fecha o row-->
            </div>
            <!--fecha o container-->
        </div>

    </div>
    <!--Fechando o Container-->

</main>

<!-- Footer and copyright -->
<footer-component></footer-component>
